export function resolveLogoSrc(companyLogo) {
	if (!companyLogo) return null;
	if (companyLogo.startsWith("data:") || companyLogo.startsWith("http")) return companyLogo;
	return null; // legacy filename from the server with no known public URL scheme yet
}

export function getAgentInitials(agent) {
	const source = (agent && (agent.company_name || agent.name)) || "?";
	return source.trim().charAt(0).toUpperCase();
}
